import { Header } from 'antd/es/layout/layout';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { useMediaType } from 'technical/media/hooks';

import styles from './index.module.scss';

export const HeaderContainer = ({ children }: PropsWithChildren) => {
  const { isMobile } = useMediaType();
  return (
    <Header
      className={classNames(
        styles.header,
        isMobile ? styles.mobileHeader : undefined,
      )}
    >
      {children}
    </Header>
  );
};
